import { Card } from "@/shared/ui/card.tsx";
import { ChartConfig, ChartContainer, ChartTooltip, ChartTooltipContent } from "@/shared/ui/chart.tsx";
import { TrendingDown, TrendingUp } from "lucide-react";
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts";

const chartData = [
  { month: "Jan", views: 186, mobile: 80 },
  { month: "Feb", views: 305, mobile: 200 },
  { month: "Mar", views: 237, mobile: 120 },
  { month: "Apr", views: 73, mobile: 190 },
  { month: "May", views: 209, mobile: 130 },
  { month: "June", views: 214, mobile: 140 },
  { month: "Jul", views: 214, mobile: 140 },
  { month: "Aug", views: 214, mobile: 140 },
]

const chartConfig = {
  views: {
    label: "Views",
    color: "#3b83f6",
  },
} satisfies ChartConfig

const SummaryGrid = () => {
  return (
    <div className="w-full px-5 md:px-16">
      <section className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 w-full h-1/3">
        <Card className="lg:col-span-2 sm:row-span-2 p-2 md:p-5">
          <ChartContainer config={chartConfig} className="min-h-[200px] w-full -ms-5 -mb-4">
            <BarChart accessibilityLayer data={chartData} width={120} barGap={30} barSize={15}>
              <CartesianGrid strokeDasharray="3" vertical={false} />
              <YAxis strokeDasharray="10" stroke="#bdbdbd" />
              <XAxis strokeDasharray="10" stroke="#bdbdbd" axisLine={false} dataKey="month" />
              <ChartTooltip content={<ChartTooltipContent />} cursor={false} />
              <Bar dataKey="views" fill="#3c82f560" radius={28} activeBar={{ fill: "#3c82f5" }} />
            </BarChart>
          </ChartContainer>
        </Card>
        <Card className="flex flex-col justify-between gap-1 p-5">
          <div className=" w-full flex items-center justify-around">
            <div className="flex flex-col gap-1 w-1/2">
              <p className="font-poppins text-md text-gray-400 font-light">Audience Reach</p>
              <h3 className="text-3xl font-bold font-montserrat tracking-wider">63,456</h3>
            </div>
            <div className="w-1/2 flex items-center justify-center">
              <TrendingUp strokeWidth={2} color="#a9ff8a" className="w-[800px] h-[80px] lg:w-[800px] lg:h-[80px]" />
            </div>
          </div>
          <div className="flex items-center w-full justify-between">
            <p className="text-xs text-gray-600"><span className="text-emerald-700 font-semibold">+12%</span> from last week</p>
            <p className="text-xs text-gray-600"><span className="text-emerald-700 font-semibold">+6%</span></p>
          </div>
        </Card>
        <Card className="flex flex-col justify-between gap-1 p-5">
          <div className=" w-full flex items-center justify-around">
            <div className="flex flex-col gap-1 w-1/2">
              <p className="font-poppins text-md text-gray-400 font-light">Total Likes</p>
              <h3 className="text-3xl font-bold font-montserrat tracking-wider">10,256</h3>
            </div>
            <div className="w-1/2 flex items-center justify-center">
              <TrendingDown strokeWidth={2} color="#ff724f" className="w-[800px] h-[80px] lg:w-[800px] lg:h-[80px]" />
            </div>
          </div>
          <div className="flex items-center w-full justify-between">
            <p className="text-xs text-gray-600"><span className="text-red-400 font-semibold">-7%</span> from last week</p>
            <p className="text-xs text-gray-600"><span className="text-emerald-700 font-semibold">+6%</span></p>
          </div>
        </Card>
        <Card className="flex flex-col justify-between gap-1 p-5">
          <div className=" w-full flex items-center justify-around">
            <div className="flex flex-col gap-1 w-1/2">
              <p className="font-poppins text-md text-gray-400 font-light">Total Views</p>
              <h3 className="text-3xl font-bold font-montserrat tracking-wider">23,456</h3>
            </div>
            <div className="w-1/2 flex items-center justify-center">
              <TrendingUp strokeWidth={2} color="#a9ff8a" className="w-[800px] h-[80px] lg:w-[800px] lg:h-[80px]" />
            </div>
          </div>
          <div className="flex items-center w-full justify-between">
            <p className="text-xs text-gray-600"><span className="text-emerald-700 font-semibold">+12%</span> from last week</p>
            <p className="text-xs text-gray-600"><span className="text-emerald-700 font-semibold">+6%</span></p>
          </div>
        </Card>
        <Card className="flex flex-col justify-between gap-1 p-5">
          <div className=" w-full flex items-center justify-around">
            <div className="flex flex-col gap-1 w-1/2">
              <p className="font-poppins text-md text-gray-400 font-light">Reposts</p>
              <h3 className="text-3xl font-bold font-montserrat tracking-wider">2,456</h3>
            </div>
            <div className="w-1/2 flex items-center justify-center">
              <TrendingUp strokeWidth={2} color="#a9ff8a" className="w-[800px] h-[80px] lg:w-[800px] lg:h-[80px]" />
            </div>
          </div>
          <div className="flex items-center w-full justify-between">
            <p className="text-xs text-gray-600"><span className="text-emerald-700 font-semibold">+12%</span> from last week</p>
            <p className="text-xs text-gray-600"><span className="text-emerald-700 font-semibold">+6%</span></p>
          </div>
        </Card>
      </section>
    </div>
  )
}

export default SummaryGrid;
